<script setup>
import { NuxtLink } from '#components'
import { useApi } from '../composables/useApi.ts'

const isLoading = ref(true)
const listings = ref([])
const usedCategories = ref([])

const fetchListings = async () => {
  try {
    listings.value = await useApi('listings', {
      method: 'GET',
      query: { action: 'get-all' }
    })
  } catch (err) {
    console.error('Error fetching clients:', err.value)
  } finally {
    isLoading.value = false // Set loading state to false after data is fetched
  }
}

const fetchUsedCategories = async () => {
  try {
    usedCategories.value = await useApi('categories-in-use', {
      method: 'GET',
      query: { action: 'get-in-use' }
    })
  } catch (err) {
    console.error('Error fetching clients:', err.value)
  }
}

onMounted(async () => {
  await fetchListings()
  await fetchUsedCategories()
  /* console.log('usedCategories:', usedCategories.value) */
})
</script>

<template>
  <div>
    <h3 class="text-center">Directory of Products and Services</h3>
  </div>

  <div class="mygridder lg:grid lg:grid-cols-3 lg:gap-4 m-2 min-h-[100%]">
    <div class="bg-gray-50 p-2 border-2 rounded-md border-[maroon]">
      <p class="text-center">ALL COMPANIES LISTED IN OUR DIRECTORY</p>
      <p
        class="text-center"
        v-if="isLoading"
      >
        Loading...
      </p>
      <NuxtLink
        v-for="listing in listings"
        :key="listing.id"
        :to="`/listings/${listing.id}`"
        class="text-[blue] hover:text-[red]"
      >
        {{ listing.name }}
      </NuxtLink>
    </div>
    <div class="bg-gray-50 p-2 border-2 rounded-md border-[maroon]">
      <p class="text-center">
        SEARCH FOR LISTED COMPANIES, PRODUCTS AND SERVICES
      </p>
      <div class="category-form-text my-2">
        <form
          action=""
          class="flex flex-col gap-2"
        >
          <input
            type="text"
            placeholder="Search for products and services"
            class="p-2 rounded-md border-2 border-gray-300"
          />
          <div class="w-fit mx-auto">
            <button
              class="bg-[blue] hover:bg-[red] text-white p-2 rounded-md w-fit"
            >
              Search
            </button>
          </div>
        </form>
      </div>
      <hr class="text-black" />
      <div>
        <p class="text-center">CATEGORIES</p>
        <div class="w-full h-[8em] overflow-x-hidden overflow-y-auto">
          <ul>
            <li
              v-for="category in usedCategories"
              :key="category.id"
            >
              <NuxtLink
                :to="`../categories/${category.id}`"
                class="text-[blue] hover:text-[red]"
              >
                {{ category.name }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bg-gray-50 p-2 border-2 rounded-md border-[maroon]">
      <p class="text-center">MATCHING COMPANIES</p>
    </div>
  </div>
</template>

<style scoped>
.mygridder {
  min-height: calc(100vh - 8rem);
}
</style>
